import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset }) => {
  const regionOptions = [
    { value: 'all', label: 'All Regions' },
    { value: 'jakarta', label: 'Jakarta' },
    { value: 'surabaya', label: 'Surabaya' },
    { value: 'bandung', label: 'Bandung' },
    { value: 'medan', label: 'Medan' },
    { value: 'semarang', label: 'Semarang' }
  ];

  const periodOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'thismonth', label: 'This Month' },
    { value: 'lastmonth', label: 'Last Month' }
  ];

  const amountRangeOptions = [
    { value: 'all', label: 'All Amounts' },
    { value: '0-100000', label: 'Rp 0 - Rp 100.000' },
    { value: '100000-500000', label: 'Rp 100.000 - Rp 500.000' },
    { value: '500000-1000000', label: 'Rp 500.000 - Rp 1.000.000' },
    { value: '1000000-5000000', label: 'Rp 1.000.000 - Rp 5.000.000' },
    { value: '5000000+', label: 'Above Rp 5.000.000' }
  ];

  const merchantCategoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'retail', label: 'Retail' },
    { value: 'food', label: 'Food & Beverage' },
    { value: 'ecommerce', label: 'E-commerce' },
    { value: 'services', label: 'Services' },
    { value: 'entertainment', label: 'Entertainment' }
  ];

  const timeSlotOptions = [
    { value: 'all', label: 'All Hours' },
    { value: 'peak', label: 'Peak Hours (09:00-21:00)' },
    { value: 'offpeak', label: 'Off-Peak Hours (21:00-09:00)' }
  ];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-2 md:gap-3">
          <Icon name="Filter" size={20} className="text-primary md:w-6 md:h-6" />
          <h3 className="text-lg md:text-xl font-semibold text-foreground">
            Advanced Filters
          </h3>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Geographic Region"
          options={regionOptions}
          value={filters?.region}
          onChange={(value) => onFilterChange('region', value)}
        />

        <Select
          label="Comparison Period"
          options={periodOptions}
          value={filters?.period}
          onChange={(value) => onFilterChange('period', value)}
        />

        <Select
          label="Transaction Amount"
          options={amountRangeOptions}
          value={filters?.amountRange}
          onChange={(value) => onFilterChange('amountRange', value)}
        />

        <Select
          label="Merchant Category"
          options={merchantCategoryOptions}
          value={filters?.merchantCategory}
          onChange={(value) => onFilterChange('merchantCategory', value)}
        />

        <Select
          label="Time Slot"
          options={timeSlotOptions}
          value={filters?.timeSlot}
          onChange={(value) => onFilterChange('timeSlot', value)}
          className="md:col-span-2"
        />
      </div>
      <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-border">
        <div className="flex flex-wrap gap-2">
          {Object.entries(filters)?.map(([key, value]) => {
            if (value === 'all' || !value) return null;
            return (
              <div
                key={key}
                className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 text-primary rounded-lg text-xs md:text-sm"
              >
                <span className="font-medium capitalize">
                  {key?.replace(/([A-Z])/g, ' $1')?.trim()}:
                </span>
                <span>{value}</span>
                <button
                  onClick={() => onFilterChange(key, 'all')}
                  className="ml-1 hover:bg-primary/20 rounded-full p-0.5 transition-colors duration-250"
                >
                  <Icon name="X" size={12} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;